import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserPermissionAdminService } from 'src/app/shared/services/user-permission-admin.service';
import { PicklistComponent } from "../../../../../../../shared/components/ai-bot/utils/picklist/picklist.component";

@Component({
  selector: 'app-edit-modal',
  imports: [PicklistComponent],
  templateUrl: './edit-modal.component.html',
  styleUrl: './edit-modal.component.scss'
})
export class EditModalComponent {
  constructor(
    private bsModalRef: BsModalRef,
    protected permissionService: UserPermissionAdminService
  ) { }
}
